import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Counter } from '../Counter';
import { ActionButton } from '../common';

interface SectionHeaderWithControlsProps {
  horizontalPadding?: string;
  children: React.ReactNode;
  title: string;
  count: number;
  canCreate?: boolean;
  disabled?: boolean;
  onCreate?: () => void;
  createLabel?: string;
  createIcon?: React.ReactNode;
  button?: React.ReactNode;
  pb?: number;
}

const SectionHeaderWithControls: React.FC<SectionHeaderWithControlsProps> = ({
  horizontalPadding,
  children,
  canCreate,
  count,
  createLabel,
  onCreate,
  title,
  createIcon,
  button,
  pb = 6
}) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const defaultPadding = isLargeScreen
    ? '60px'
    : isTablet
      ? '12px'
      : isMobile
        ? '8px'
        : '16px';
  const padding = horizontalPadding || defaultPadding;
  return (
    <Box
      sx={{
        px: padding,
        mt: isMobile ? 0.5 : isTablet ? 1 : 2,
        pb: isMobile ? 0 : isTablet ? 0.5 : Math.min(pb, 2)
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        mb={isMobile ? 0.5 : isTablet ? 0.75 : 1}
        flexWrap={isMobile ? 'wrap' : 'nowrap'}
        gap={isMobile ? 0.5 : 0}
      >
        <Counter title={title ?? ''} count={count} />
        <Box display="flex" alignItems="center" gap="8px">
          {canCreate && createLabel && (
            <ActionButton
              onClick={onCreate}
              // disabled={disabled}
              disabled={true}
              startIcon={!isMobile && !isTablet ? createIcon : undefined}
              sx={{
                minWidth: isMobile || isTablet ? '32px' : 'auto',
                width: isMobile || isTablet ? '32px' : 'auto',
                height: isMobile || isTablet ? '32px' : '36px',
                padding: isMobile || isTablet ? '4px' : '6px 16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {isMobile || isTablet ? createIcon : createLabel}
            </ActionButton>
          )}
          {!canCreate && button}
        </Box>
      </Box>
      {children}
    </Box>
  );
};

export default SectionHeaderWithControls;
